const inspectByList = [
  {
    value: 1,
    text: 'Ministry of Commerce Officer',
    text_en: 'Ministry of Commerce Officer',
    text_bn: 'বাণিজ্য মন্ত্রণালয়ের কর্মকর্তা '
  },
  {
    value: 2,
    text: 'DNCRP officer',
    text_en: 'DNCRP officer',
    text_bn: 'ভোক্তা অধিকার কর্মকর্তা'
  }
]
const frequencyTypeList = [
  {
    value: 1,
    text: 'Daily',
    text_en: 'Daily',
    text_bn: 'দৈনিক'
  },
  {
    value: 2,
    text: 'Weekly',
    text_en: 'Weekly',
    text_bn: 'সাপ্তাহিক'
  },
  {
    value: 3,
    text: 'Monthly',
    text_en: 'Monthly',
    text_bn: 'মাসিক'
  },
  {
    value: 4,
    text: 'Yearly',
    text_en: 'Yearly',
    text_bn: 'বার্ষিক'
  }
]

const frequencyTypeList2 = [
  {
    value: 1,
    text: 'Daily',
    text_en: 'Daily',
    text_bn: 'দৈনিক'
  },
  {
    value: 2,
    text: 'Weekly',
    text_en: 'Weekly',
    text_bn: 'সাপ্তাহিক'
  },
  {
    value: 3,
    text: 'Monthly',
    text_en: 'Monthly',
    text_bn: 'মাসিক'
  },
  {
    value: 4,
    text: 'Quarterly',
    text_en: 'Quarterly',
    text_bn: 'ত্রৈমাসিক'
  },
  {
    value: 5,
    text: 'Half Yearly',
    text_en: 'Half Yearly',
    text_bn: 'ষাণ্মাসিক'
  },
  {
    value: 6,
    text: 'Yearly',
    text_en: 'Yearly',
    text_bn: 'বার্ষিক'
  }
]
export default {
  inspectByList,
  frequencyTypeList,
  frequencyTypeList2
}
